import { Helmet } from 'react-helmet';
import { useCurrentCountry } from 'utils/hooks';

function DimensionHelmet({ name, type, hierarchy_hint }) {
    const country = useCurrentCountry();
    if (!(name && type)) {
        return null;
    }

    let title = `SPATE: ${name}`;

    if (type === 'affinity') {
        title += ' (related search)';
    } else if (type === 'brand') {
        title += ' (brand)';
    }

    title = [title];

    if (country && country.text_id) {
        title.push(country.text_id.toLowerCase());
    }

    if (hierarchy_hint) {
        const hierarchy = Object.values(hierarchy_hint);
        title = title.concat(hierarchy.slice(0, hierarchy.length - 1));
    }

    return (
        <Helmet>
            <title>{title.join(' : ')}</title>
        </Helmet>
    );
}

export default DimensionHelmet;
